import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
} from "reactstrap";
import moment from "moment";
import get from "lodash/get";
import { useEffect, useState } from "react";
import CustomDatepicker from "../CustomDatepicker";
import history from "../../history";
import CartTitle from "../../components/CartTitle";
import Loader from "../Loader";
import InputText from "../InputText";
import { close } from "react-icons-kit/fa/close";
import { Icon } from "react-icons-kit";
import { ic_file_upload } from "react-icons-kit/md/ic_file_upload";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";

import "../../assets/scss/components/MeterialTable/index.scss";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { nameValidation } from "../../utils/helperFunction";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActions from "../../redux/Testimonials/action";
import * as globalActions from "../../redux/Global/actions";
import { validation } from "../../helpers/validation";
import TestimonialPreviewPage from "../TestimonialPreviewPages";

const _ = { get };

class AddNewTestimonial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      description: "",
      postedDate: "",
      country: "",
      image: "",
      thumbnailImagePlaceholder: "",
      errors: {},
      togglePreviewModal: false,
      partnerName: "",
      partnerEmailId: "",
      updatedDetails: {},
    };
  }

  componentDidMount() {
    let state = this.state;
    if (this.props.testimonialsDetailsData) {
      state.name = this.props.testimonialsDetailsData.author;
      state.description = this.props.testimonialsDetailsData.description;
      state.postedDate = new Date(
        this.props.testimonialsDetailsData.postedDate
      );
      state.country = this.props.testimonialsDetailsData.location;
      state.image = this.props.testimonialsDetailsData.image.images[0].srcPath;
      state.thumbnailImagePlaceholder = this.props.testimonialsDetailsData.image.images[0].srcPath.split(
        "/"
      )[5];
    }
    this.setState({ ...state });
  }

  handleCreateTestimonial = (data) => {
    if (this.state.errors && Object.keys(this.state.errors).length === 0) {
      this.props.actions.createTestimonial(data, this.handleCallBack);
    }
  };

  handleCallBack = () => {
    this.props.handleToggleModel();
    this.props.handleFetchTestimonialList({
      page: 0,
      country: "",
      state: "",
      city: "",
      email: "",
      phone: "",
      limit: 100,
      status: "PENDING",
    });
  };

  handleUpdateTestimonial = (data) => {
    if (this.state.errors && Object.keys(this.state.errors).length === 0) {
      this.props.actions.updateTestimonial(data, this.handleUpdateCallBack);
    }
  };

  handleUpdateCallBack = () => {
    this.props.handleToggleModel();
    this.props.actions.fetchTestimonialDetails(
      this.props.testimonialsDetailsData &&
        this.props.testimonialsDetailsData._id
    );
  };

  clearingPreviousReducer = (data) => {
    this.props.actions.clearingPreviousReducer(data);
  };

  handleChange = (e) => {
    let state = this.state;
    let value = e.target.value;
    // if (value.match(nameValidation)) {
    state[e.target.name] = value;
    // }
    let errorMessage = validation(
      e.target.name,
      e.target.value,
      this.props.elements
    );
    if (errorMessage) {
      state.errors[e.target.name] = errorMessage;
    } else {
      delete state.errors[e.target.name];
    }
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        [e.target.name]: e.target.value,
      };
    }
    this.setState({ ...state });
  };

  handleRiderNoteChange = (e) => {
    let state = this.state;
    let value = e.target.value;
    state[e.target.name] = value;

    this.setState({ ...state });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    state.country = e.target.value;
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        location: e.target.value,
      };
    }
    this.setState({ ...state });
  };

  // handleDescriptionChange = (e, editor) => {
  //   const data = editor.getData();
  //   this.setState({ description: data });
  //   if (this.props.formType == "update") {
  //     var body = data.replace("<p>", "");
  //     var rowdata = body.replace("</p>", "");
  //     this.setState({
  //       updatedDetails: {
  //         ...this.state.updatedDetails,
  //         description: rowdata,
  //       },
  //     });
  //   }
  // };

  // handleDescriptionSetData = (editor) => {
  //   editor.setData(this.state.description);
  // };

  handlePostedDates = (date, id) => {
    let state = this.state;
    if (id === "postedDate") {
      state.postedDate = date;
      this.setState({ ...state });
    }
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        postedDate: date,
      };
    }
  };

  handleBack = () => {
    this.props.handleToggleModel();
  };

  ValidateImg = (file, widths, heights, callBack) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = function() {
      if (img.width === widths && img.height === heights) {
        callBack(file);
      } else {
        callBack(file, widths, heights, "errors");
      }
    };
    console.log("widths", widths);
  };

  callBackOnUpload = (file, width, height, error) => {
    if (!error) {
      let newState = { ...this.state };
      let errorMessage = "";
      errorMessage = validation(
        newState.thumbnailImagePlaceholder,
        file.size,
        this.props.elements
      );
      if (errorMessage) {
        toast.error(errorMessage);
        newState.errors[newState.thumbnailImagePlaceholder] = errorMessage;
      } else {
        delete newState.errors[newState.thumbnailImagePlaceholder];
        errorMessage = "";

        newState.thumbnailImagePlaceholder = file.name.split(" ")[0];
        this.props.actions.uploadUrl(file, this.onImageChangeHandler);
      }
      this.setState(newState);
    }
    if (error) {
      toast.error(
        `${_.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.galleryImageDimensionValidationElement",
          `Image dimensions must be equal to`
        )} ${width} x ${height}`
      );
    }
  };

  onImageUpload = (e) => {
    if (this.state.image !== "" || Array.from(e.target.files).length > 1) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.addNewTestimonials.galleryMinUploadValidation",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      let newState = { ...this.state };
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.testimonialDimensionalElement.riderImageWidthElement",
          80
        ),
        _.get(
          this.props.elements,
          "euToursElement.testimonialDimensionalElement.riderImageHeightElement",
          80
        ),
        this.callBackOnUpload
      );

      newState.eventName = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onImageChangeHandler = (data) => {
    let state = { ...this.state };
    state.image = data;
    toast.error(
      // _.get(
      //   elements,
      //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
      //   "Please select Partner Rating"
      "Images Uploaded Successfully"
    );
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        image: data,
      };
    }
    this.setState(state);
  };

  handleSubmitForm = () => {
    let { elements } = this.props;
    let state = this.state;
    // var body = state.description.replace("<p>", "");
    // var rowdata = body.replace("</p>", "");
    let data = {
      name: state.name ? state.name.trim() : "",
      postedDate: moment(state.postedDate).format("YYYY-MM-DD"),
      description: state.description,
      location: state.country,
      image: state.image,
    };
    if (state.name === "")
      return toast.error(
        _.get(
          elements,
          "euToursElement.addNewTestimonials.riderNameValidationElement",
          "Please enter rider name"
        )
      );

    if (state.country === "")
      return toast.error(
        _.get(
          elements,
          "euToursElement.addNewTestimonials.riderLocationValidationElement",
          "Please select rider location"
        )
      );

    if (state.postedDate === "")
      return toast.error(
        _.get(
          elements,
          "euToursElement.addNewTestimonials.postedDateValidationElement",
          "Please select posted date"
        )
      );
    if (state.description === "")
      return toast.error(
        _.get(
          elements,
          "euToursElement.addNewTestimonials.riderNoteValidationElement",
          "Please enter rider note"
        )
      );

    if (state.image === "")
      return toast.error(
        _.get(
          elements,
          "euToursElement.addNewTestimonials.uploadImageValidationElement",
          "Please upload image"
        )
      );

    if (this.state.errors && Object.keys(this.state.errors).length === 0) {
      return this.handleCreateTestimonial(data);
    }
  };

  handleUpdateForm = (e) => {
    let state = { ...this.state };
    let { elements } = this.props;
    // var body = state.description.replace("<p>", "");
    // var rowdata = body.replace("</p>", "");
    if (this.props.formType == "update") {
      let data = {
        ...state.updatedDetails,
        testimonialId: this.props.testimonialsDetailsData._id,
      };
      if (state.name === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.riderNameValidationElement",
            "Please enter rider name"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.riderLocationValidationElement",
            "Please select rider location"
          )
        );

      if (state.postedDate === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.postedDateValidationElement",
            "Please select posted date"
          )
        );
      if (state.description === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.riderNoteValidationElement",
            "Please enter rider note"
          )
        );

      if (state.image === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.uploadImageValidationElement",
            "Please upload image"
          )
        );
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.props.actions.updateTestimonialDetails(
          data,
          this.handleUpdateCallBack
        );
      }
    } else {
      let data = {
        name: state.name ? state.name.trim() : "",
        postedDate: moment(state.postedDate).format("YYYY-MM-DD"),
        description: state.description,
        location: state.country,
        image: state.image,
        testimonialId:
          this.props.testimonialsDetailsData &&
          this.props.testimonialsDetailsData._id,
      };
      if (state.name === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.riderNameValidationElement",
            "Please enter rider name"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.riderLocationValidationElement",
            "Please select rider location"
          )
        );

      if (state.postedDate === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.postedDateValidationElement",
            "Please select posted date"
          )
        );
      if (state.description === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.riderNoteValidationElement",
            "Please enter rider note"
          )
        );

      if (state.image === "")
        return toast.error(
          _.get(
            elements,
            "euToursElement.addNewTestimonials.uploadImageValidationElement",
            "Please upload image"
          )
        );
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.handleUpdateTestimonial(data);
      }
    }
  };

  handleDeleteImage = () => {
    let state = { ...this.state };
    state.thumbnailImagePlaceholder = "";
    state.image = "";
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        image: state.image,
      };
    }
    this.setState(state);
  };

  handleModal = () => {
    let state = { ...this.state };
    state.togglePreviewModal = !state.togglePreviewModal;
    this.setState(state);
  };

  componentDidMount() {
    if (this.props.testimonialsDetailsData) {
      let state = { ...this.state };
      state.name = this.props.testimonialsDetailsData.author;
      state.description = this.props.testimonialsDetailsData.description;
      state.postedDate = new Date(
        this.props.testimonialsDetailsData.postedDate
      );
      state.country = this.props.testimonialsDetailsData.location;
      state.image = this.props.testimonialsDetailsData.image.images[0].srcPath;
      state.thumbnailImagePlaceholder =
        this.props.testimonialsDetailsData &&
        this.props.testimonialsDetailsData.image &&
        this.props.testimonialsDetailsData.image.images &&
        this.props.testimonialsDetailsData.image.images[0] &&
        this.props.testimonialsDetailsData.image.images[0].srcPath &&
        this.props.testimonialsDetailsData.image.images[0].srcPath.split(
          "/"
        )[5];
      state.partnerName =
        this.props.testimonialsDetailsData &&
        this.props.testimonialsDetailsData.createdBy &&
        this.props.testimonialsDetailsData.createdBy.name;
      state.partnerEmailId =
        this.props.testimonialsDetailsData &&
        this.props.testimonialsDetailsData.createdBy &&
        this.props.testimonialsDetailsData.createdBy.email;
      this.setState(state);
    }
  }

  render() {
    let { elements } = this.props;
    console.log("event", this.state);
    return (
      <div className="hideSearch mt-4">
        {console.log("state", this.props.testimonialsDetailsData)}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.image === "" &&
          this.state.thumbnailImagePlaceholder && <Loader />}
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "euToursElement.addNewTestimonials.addNewTestimonialHeadingElement",
                  "Add New Testimonial"
                )}
                Name={"Filter"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>

            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName="Rider Name"
                        mandatory
                        inputType={"text"}
                        inputName={"name"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTestimonials.riderNameElement",
                          "Rider Name"
                        )}
                        customValue={this.state.name}
                        customMaxLength={75}
                        customMinLength={2}
                        customOnChange={(e) => this.handleChange(e)}
                      />
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.name && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.name}
                          </div>
                        )}
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTestimonials.riderLocationElement",
                          "Rider Location"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className="confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          onChange={this.handleCountryChange}
                          value={this.state.country}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.addNewTestimonials.riderLocationElement",
                              "Rider Location"
                            )}
                          </option>
                          {this.props.testimonialCountriesJson &&
                            Object.values(this.props.testimonialCountriesJson)
                              .length > 0 &&
                            Object.values(
                              this.props.testimonialCountriesJson
                            ).map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTestimonials.postedDateElement",
                          "Posted Date"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.postedDate}
                          customPlaceHolder="Posted Date"
                          handleDateChange={(e) =>
                            this.handlePostedDates(e, "postedDate")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMaxDate={new Date()}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="each_input" xl={12}>
                      <Label className="inputLabel" for="--">
                        {_.get(
                          elements,
                          "euToursElement.addNewTestimonials.riderNoteElement",
                          "Rider Note"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup>
                        {/* <CKEditor
                          editor={ClassicEditor}
                          onInit={(editor) =>
                            this.handleDescriptionSetData(editor)
                          }
                          data={this.state.description}
                          onChange={(e, editor) =>
                            this.handleDescriptionChange(e, editor)
                          }
                        /> */}
                        <InputText
                          // labelName={_.get(
                          //   elements,
                          //   "euToursElement.addNewTestimonials.riderNoteElement",
                          //   "Rider Note"
                          // )}
                          inputType={"textarea"}
                          inputName={"description"}
                          InputClass={"inputText mb-0"}
                          inputPlaceholder={_.get(
                            elements,
                            "euToursElement.addNewTestimonials.riderNoteElement",
                            "Rider Note"
                          )}
                          customOnChange={this.handleChange}
                          customValue={this.state.description}
                        />
                      </FormGroup>
                    </Col>

                    <Col xl={4}>
                      <div>
                        <label className="inputLabel">
                          {_.get(
                            elements,
                            "euToursElement.addNewTestimonials.riderImageElement",
                            "Rider Image/Default image (80 x 80 px)"
                          )}
                          <span className="mandate_mark">*</span>
                        </label>
                        <div className="d-flex form-control file-inputMain">
                          <input
                            type="file"
                            name="image"
                            accept=".jpg, .jpeg, .png, .webp"
                            placeholder={_.get(
                              elements,
                              "euToursElement.addNewTestimonials.riderImageElement",
                              "Rider Image/Default image (80 x 80 px)"
                            )}
                            className="inputText mb-0"
                            onChange={(e) => this.onImageUpload(e)}
                          />
                          <Icon
                            className="text-dark uploadIcon"
                            size={18}
                            icon={ic_file_upload}
                          />
                          {this.state.thumbnailImagePlaceholder !== "" &&
                            this.state.thumbnailImagePlaceholder !==
                              undefined && (
                              <div className="file-name mr-2">
                                <div className="file-large-name">
                                  {this.state.thumbnailImagePlaceholder}
                                </div>
                                <Icon
                                  className="closeIcon"
                                  size={18}
                                  icon={close}
                                  onClick={() => this.handleDeleteImage()}
                                />
                              </div>
                            )}
                        </div>
                        <div className="image_rules">
                          {_.get(
                            elements,
                            "euToursElement.addNewTestimonials.riderImageFormatElement",
                            "Format: JPG PNG JPEG WEBP. Max Size: 1MB."
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col className="top_line" md="12"></Col>
                  </Row>
                  <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5 mb-4">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.addNewTestimonials.backButtonElement",
                        "Back"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => this.handleBack()}
                    />
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "landingPageElement.searchButtonElementll",
                        "Preview"
                      )}
                      customClass={
                        "btn-outline-dark ml-2 bg-none btnthemeColor"
                      }
                      customClick={this.handleModal}
                    />
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.addNewTestimonials.submitButtonElement",
                        "Submit"
                      )}
                      customClick={() =>
                        this.props.testimonialsDetailsData
                          ? this.handleUpdateForm()
                          : this.handleSubmitForm()
                      }
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
        <Modal
          isOpen={this.state.togglePreviewModal}
          toggle={() => this.handleModal()}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <TestimonialPreviewPage
              handleToggleModel={() => this.handleModal()}
              testimonialData={this.state}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    global: bindActionCreators(globalActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    countryStatus: state.Events.countryStatus,
    tourCountriesJson: state.Global.tourCountriesJson,
    createTestimonialStatus: state.Testimonials.createTestimonialStatus,
    userProfile: state.Auth.userProfile,
    elements: state.Elements.elements,
    documentRead: state.Testimonials.documentRead,
    testimonialCountriesJson: state.Global.testimonialCountriesJson,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddNewTestimonial)
);
